import { parseNoteContent } from '@/lib/utils'
import { Fragment } from 'react'
import { parseNoteSegments } from './note-mentions'

export function NoteContent({ content }: { content: string }) {
	const text = parseNoteContent(content) ?? ''

	return (
		<p className="text-sm text-gray-500 whitespace-pre-wrap">
			{parseNoteSegments(text).map((segment, index) =>
				segment.type === 'mention'
					? (
						<span key={index} className="rounded bg-brand-50 px-1 font-medium text-brand-700">
							@{segment.name}
						</span>
					)
					: <Fragment key={index}>{segment.text}</Fragment>
			)}
		</p>
	)
}
